// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5d-5";
export var imageContainer = "_5d-4";
export var metricsGrid = "_5d-2";
export var productDetailContainer = "_5d-1";
export var productListContainer = "_5d-0";
export var subscriberTableContainer = "_5d-3";